"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseableUtil = void 0;
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
/**
 * Validate a given object regarding the passed `UseableValidation`.
 * It can be used for a variety of type guards using the `Useable` type constructions.
 */
class UseableUtil {
    // eslint-disable-next-line
    static createGuard(def) {
        return (whatever, v) => UseableUtil.validateDef(whatever, def, v);
    }
    static validateDef(whatever, def, // eslint-disable-line
    v) {
        return ((def.parent ? UseableUtil.validateDef(whatever, def.parent, v) : true) &&
            UseableUtil.validate(whatever, def.validation, v));
    }
    // eslint-disable-next-line
    static createUnsafeGuard(def) {
        return (whatever, v) => UseableUtil.validateUnsafeDef(whatever, def, v);
    }
    static validateUnsafeDef(whatever, def, // eslint-disable-line
    v) {
        return ((def.parent ? UseableUtil.validateUnsafeDef(whatever, def.parent, v) : true) &&
            UseableUtil.validate(whatever, def.unsafeValidation || def.validation, v));
    }
    static validate(whatever, useableValidation, validation) {
        if (!(0, echain_shared_ts_utils_1.isDefinedObject)(whatever)) {
            return false;
        }
        const item = whatever;
        return Object.entries(useableValidation).every(([key, validity]) => {
            const value = item[key];
            if (typeof validity === 'function') {
                const isValid = validity(value, item);
                if (!isValid && validation) {
                    validation.add(UseableUtil.invalidKeyPrefix + key);
                }
                return isValid;
            }
            // required
            if (validity === true) {
                const isValid = value != null;
                if (!isValid && validation) {
                    validation.add(UseableUtil.invalidKeyPrefix + key);
                }
                return isValid;
            }
            // undef
            const isValidUndef = value == null;
            if (!isValidUndef && validation) {
                validation.add(UseableUtil.invalidKeyPrefix + key);
            }
            return isValidUndef;
        });
    }
    /** retrieves all property keys as array */
    static toPropKeys(validation) {
        return Object.entries(validation).map(([key]) => key);
    }
}
exports.UseableUtil = UseableUtil;
UseableUtil.invalidKeyPrefix = 'useable_validation_invalid_key_';
//# sourceMappingURL=UseableUtil.js.map